import React from "react";
// import Sidebar from "../dashboard/Sidebar";
import Header from "../dashboard/Header";
import HistoryContent from "./HistoryContent";
import DashboardLayout from "../../layout/dashboardLayout";

const History = () => {
  return (
    <DashboardLayout>
      <HistoryContent />
    </DashboardLayout>
  );
  // return (
  //   <div className="dashboard_sec">
  //     <div className="container-fluid d-flex px-0">
  //       <div className="left_side_sec">
  //         <Sidebar />
  //       </div>
  //       <div className="right_side_sec px-2 py-2 px-sm-4 py-sm-4">
  //         <Header />
  //         <HistoryContent />
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default History;
